import * as React from 'react';

export { default as loadable } from '@loadable/component';

import { Loading } from '@common/react/components/UI/Loading/Loading';

function delay(ms: number): Promise<void> {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
}

export function loadableDelay<T>(promise: Promise<T>): Promise<T> {
	if (typeof window === 'undefined') return promise;

	return Promise
		.all([promise, delay(200)])
		.then(([val]) => val);
}

interface LoadableParams<T extends Record<string, React.ReactElement>> {
	fallback: React.ReactNode;
	resolveComponent: (module: T) => React.ReactElement;
}

export const params: Pick<LoadableParams<never>, 'fallback'> = {
	fallback: <Loading />,
};

// Update @loadable/component and @loadable/server to version 5.13.1
export function getParams<T extends Record<string, React.ReactElement>>(componentName: keyof T): LoadableParams<T> {
	return {
		...params,
		resolveComponent: (module: T) => module[componentName],
	};
}
